import React from "react";
import DimaondShape from "./homecomponent/dimaondShape";

const Benefits = () => {
  const diaNum1 = "01";
  const diaNum2 = "02";
  const diaNum3 = "03";
  const diaNum4 = "04";
  const diaNum5 = "05";

  const diaHead1 = "Cost Effective";
  const diaHead2 = "24/7 Service";
  const diaHead3 = "Call Scheduling";
  const diaHead4 = "Fast";
  const diaHead5 = "Privacy";

  const para1 =
    "We aim to deliver high-quality services within budget constraints, ensuring efficiency and cost-effectiveness in all aspects of the project.";

  const para2 =
    "It is available around the clock, addressing client needs and concerns promptly for a reliable and responsive service.";
  const para3 =
    "We upgraded communication with organized, scheduled calls for efficient and convenient client updates.";
  const para4 =
    "We emphasize speed and efficiency, dedicated to completing tasks promptly through streamlined processes and effective  management";
  const para5 =
    "It ensures the protection of sensitive information, maintaining a secure and private environment throughout the project.";
  return (
    <>
      <div className="benefitBanner">
        <img
          className="blueprintright"
          src="../../../images/home/benefit-right-blueprint.png"
          alt=""
        />

        <img
          className="blueprintbottom"
          src="../../../images/home/benefit-right-blueprint.png"
          alt=""
        />

        <img className="gridbg" src="../../../images/home/gridbg.png" alt="" />

        <div className="gradient-horiz-line"></div>
        <p className="top-heading mt-4">BENEFITS</p>
        <p className="main-gradient-heading">Group LanDev AI</p>
        <span className="sub-heading ">Realizing Unmatched Advantages</span>
        <p className="lorem-text">
          Elevate Your Projects with Precision, Efficiency, and Creative
          Brilliance!
        </p>
        <div className="diamondContainer">
          <DimaondShape
            diamondnum={diaNum1}
            diamondhead={diaHead1}
            diamondPara={para1}
          />
          <DimaondShape
            diamondnum={diaNum2}
            diamondhead={diaHead2}
            diamondPara={para2}
          />
          <DimaondShape
            diamondnum={diaNum3}
            diamondhead={diaHead3}
            diamondPara={para3}
          />
        </div>
        <div className="diamondContainer mb-5">
          <DimaondShape
            diamondnum={diaNum4}
            diamondhead={diaHead4}
            diamondPara={para4}
          />
          <DimaondShape
            diamondnum={diaNum5}
            diamondhead={diaHead5}
            diamondPara={para5}
          />
        </div>
      </div>
    </>
  );
};

export default Benefits;
